export const ROW_SELECTED_BG =
  'bg-[color-mix(in_oklab,var(--color-card),var(--color-brand-link)_18%)] hover:bg-[color-mix(in_oklab,var(--color-card),var(--color-brand-link)_18%)]';

export const ROW_SELECTED_MARK_CLASS =
  '[&>td:first-child]:shadow-[inset_3px_0_0_var(--color-brand-link)]';

export const ROW_HOVER_BG =
  'hover:bg-[color-mix(in_oklab,var(--color-card),var(--color-brand-link)_12%)]';

export const STICKY_COL_SELECTED_BG =
  'lg:bg-[color-mix(in_oklab,var(--color-card),var(--color-brand-link)_18%)]';

export const STICKY_COL_DEFAULT_BG =
  'lg:bg-card lg:group-hover/row:bg-[color-mix(in_oklab,var(--color-card),var(--color-brand-link)_12%)]';

export const TABLE_HEADER_BG = 'bg-table-header';

export const TABLE_HEADER_TEXT_CLASS = 'text-primary-strong';

export const TABLE_HEADER_CLASS = `${TABLE_HEADER_BG} [&_th]:text-primary-strong`;

export const STICKY_COL_HEADER_BG = 'lg:bg-table-header';
